/*
 * aiflow 流程图组件
 *
 */
import AIFlow from 'aiflow';
import * as React from 'react';
export default React.forwardRef((props, ref) => {
    const { width = 400, height = 400, classname, style, data, config, templates } = props;
    const domRef = React.useRef();
    const [ins, setIns] = React.useState();
    React.useEffect(() => {
        if (templates && templates.length) {
            templates.forEach((t) => {
                AIFlow.registerTemplate(t.name, t.content);
            });
        }
        const aiIns = new AIFlow(domRef.current, data, config);
        setIns(aiIns);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templates]);
    React.useImperativeHandle(ref, () => {
        return { ins };
    }, [ins]);
    return <div className={classname} ref={domRef} style={Object.assign({ width, height }, style)}></div>;
});
